export default { invoiceReview: {
  'title': 'Invoice Review',
  'subtitle': 'Review manual and ticket charges before invoices are issued.',
  'week': 'Week',
  'client': 'Customer',
  'allClients': 'All customers',
  'invoiceNo': 'Invoice number',
  'source': 'Source',
  'allSources': 'All sources',
  'charge': 'Charge item',
  'allCharges': 'All charges / code',
  'status': 'Review status',
  'allStatuses': 'All statuses',
  'unreviewed': 'Not reviewed',
  'reviewed': 'Reviewed',
  'search': 'Search',
  'reset': 'Reset',
  'refresh': 'Refresh',
  'progress': '{reviewed} of {total} invoices reviewed',
  'manualSubtotal': 'Manual charges · Excl. GST',
  'items': 'items',
  'history': 'Operation history',
  'markReviewed': 'Mark reviewed',
  'quantity': 'Quantity',
  'unit': 'Unit',
  'unitPrice': 'Unit price',
  'amount': 'Amount (excl. GST)',
  'ticket': 'Ticket no.',
  'actions': 'Actions',
  'editQuantity': 'Edit quantity',
  'delete': 'Delete',
  'invoiceTotal': 'Invoice subtotal',
  'exTax': 'Excl. GST',
  'lastReviewed': 'Last reviewed by',
  'loadMore': 'Load more',
  'empty': 'No invoices to review',
  'emptyHint': 'Change the week or filters to find preview invoices with manual or ticket charges.',
  'noRows': 'No matching charges',
  'toggle': 'Expand or collapse invoice',
  'filteredScope': 'Detail filters are active. Invoice subtotals and review status always cover all manual and ticket charges. Mark reviewed applies to the entire invoice.',
  'dataError': 'Data issue',
  'deleteTitle': 'Delete transaction',
  'editTitle': 'Edit quantity',
  'deleteWarning': 'This transaction will be deleted and the invoice refreshed immediately. The invoice is deleted only when no effective charges remain under the existing empty-invoice rule; other valid charges keep it open.',
  'savedPrice': 'Saved unit price · Read only',
  'calculate': 'Calculate',
  'reason': 'Reason',
  'reasonHint': 'Explain the adjustment for the operation log',
  'cancel': 'Cancel',
  'confirmDelete': 'Delete and refresh',
  'saveRefresh': 'Save and refresh',
  'before': 'Before',
  'after': 'After',
  'requestFailed': 'Request failed. Your input has been kept; retry or refresh the invoice.',
  'changed': 'The invoice changed. Reload it before continuing.',
  'reloadCompare': 'Reload latest invoice and compare (keep my input)',
  'rowRemoved': 'This transaction no longer exists in the invoice.',
  'compareQuantity': 'Latest saved quantity: {quantity}. Your input has been kept. Compare and calculate again before saving.',
  'saved': 'Invoice refreshed successfully',
  'invoiceDeleted': 'Transaction deleted. The empty invoice was deleted; its operation history is retained.',
  'reviewTitle': 'Review the complete invoice scope',
  'reviewScope': 'Confirm all {count} manual and ticket charges, subtotal ${subtotal} excluding GST. This marks the entire invoice as reviewed.',
  'resolveErrors': 'Resolve the Ticket data issues before marking this invoice reviewed.',
  'reviewSaved': 'Invoice marked as reviewed',
  'noHistory': 'No operation history yet',
  'batchReview': 'This selection includes Invoice Review transactions. Open Invoice Review and handle them individually.',
  'openReview': 'Review'
} };
